import { AccountDeletionAccepted } from '../../domain/models/account-deletion.model';

export interface AccountDeletionAcceptedDto {
  readonly RequestId: string;
  readonly ExecuteAfterUtc: string;
  readonly CancellationToken: string;
}

export function mapAccountDeletionAccepted(dto: AccountDeletionAcceptedDto): AccountDeletionAccepted {
  return { requestId: dto.RequestId, executeAfterUtc: dto.ExecuteAfterUtc, cancellationToken: dto.CancellationToken };
}
